import "./galerie.css";

import img1 from "../assets/img/gallery/2023_September_Brombeere.webp";
import img2 from "../assets/img/gallery/2023_September_Kuh.webp";
import img3 from "../assets/img/gallery/2023_September_See.webp";
import img4 from "../assets/img/gallery/2023_September_Weg.webp";
import img5 from "../assets/img/gallery/2023_September_Wiese.webp";

import img6 from "../assets/img/gallery/2023_März_Danke.webp";
import img7 from "../assets/img/gallery/2023_März_Regenbogen.webp";
import img8 from "../assets/img/gallery/2023_März_Spirale.webp";

import img9 from "../assets/img/gallery/2023_Januar_Bach.webp";
import img10 from "../assets/img/gallery/2023_Januar_Baum.webp";
import img11 from "../assets/img/gallery/2023_Januar_Schnee.webp";
import img12 from "../assets/img/gallery/2023_Januar_Tisch.webp";
import img13 from "../assets/img/gallery/2023_Januar_Wald.webp";

import img14 from "../assets/img/gallery/2022_November_Landschaft.webp";
import img15 from "../assets/img/gallery/2022_November_See.webp";
import img16 from "../assets/img/gallery/2022_November_Spaziergang.webp";
import img17 from "../assets/img/gallery/2022_November_Wörter.webp";

import img18 from "../assets/img/gallery/2022_Juli_Pfad.webp";
import img19 from "../assets/img/gallery/2022_Juli_See.webp";
import img20 from "../assets/img/gallery/2022_Juli_Wald.webp";
import img21 from "../assets/img/gallery/2022_Juli_Zettel.webp";

import img22 from "../assets/img/gallery/2022_April_Feuer.webp";
import img23 from "../assets/img/gallery/2022_April_Papier.webp";
import img24 from "../assets/img/gallery/2022_April_Wald.webp";






function Galerie() {
  return <div className="main-wrapper gallery">
    
    

    <h2>Galerie</h2>

    <h3>Sommerwochenende 2023</h3>

    <img src={img1}/>
    <img src={img2}/>
    <img src={img3}/>
    <img src={img4}/>
    <img src={img5}/>

    <h3>Frühlingswochenende 2023</h3>

    <img src={img6}/>
    <img src={img7}/>
    <img src={img8}/>

    <h3>Winterwochenende 2023</h3>

    <img src={img9}/>
    <img src={img10}/>
    <img src={img11}/>
    <img src={img12}/>
    <img src={img13}/>

    <h3>Herbstwochenende 2022</h3>

    <img src={img14}/>
    <img src={img15}/>
    <img src={img16}/>
    <img src={img17}/>

    <h3>Sommerwochenende 2022</h3>

    <img src={img18}/>
    <img src={img19}/>
    <img src={img20}/>
    <img src={img21}/>

    <h3>Frühlingswochenende 2022</h3>

    <img src={img22}/>
    <img src={img23}/>
    <img src={img24}/>


  </div>;
}
export default Galerie;